var OrangeColor = require('./src/orange-color');
module.exports = {
  OrangeColor: OrangeColor
};